import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
import Image from './images/work-projects-1.jpg'
import Image2 from './images/work-projects-2.jpg'
import SEO from '../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Work Projects" keywords={[]} />
    <div id="main" role="main">
      {' '}
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">Work Projects</h1>
        <div>
          <div className="float-left">
            <img
              className="alignleft"
              style={{ marginRight: '18px', marginTop: '5px' }}
              src={Image}
              alt="Work Projects"
              width={450}
            />
          </div>
          <p>
            ♦&nbsp;Serve as core design team members and faculty for the
            delivery of Leading with Impact, a frontline supervisory leadership
            seminar for the National Security Agency(NSA). The program is
            ongoing and will involve and impact over 2,000 agency employees
            encompassing both Signals Intelligence (SIGINT) and Information
            Assurance (IA). The competencies presented and developed range from
            situational leadership and effective delegation to conflict
            management and coaching for performance.
          </p>
          <p>
            ♦&nbsp;An executive coach for a cohort of selected high potentials
            from across multiple business units in Dow Corning’s Cross
            Functional Leadership Development Program. Guide these key future
            leaders and their direct managers through a critical mind shift to
            align development areas of focus on helping the company create
            greater collaboration across multiple stakeholders, grow globally
            through innovation and become an exceptional enterprise of over $10
            Billion annually.
          </p>
          <p>
            ♦&nbsp;Adjunct faculty members for the Duke Corporate Education
            international project Leaders in Anglo American. The project takes
            place in Santiago, Chile and involves facilitation of leadership
            development and effectiveness modules along with onsite and follow
            up executive coaching. Participants are selected high potentials and
            represent nine different countries from across six different
            business units throughout Anglo American.
          </p>
          <p>
            ♦&nbsp;Invited to be part of a cadre of master facilitators
            currently delivering a 3-day Microsoft internally developed
            Fundamentals of Management training for M1 managers throughout
            North, Central and South America, Asia, and Europe. Have brought
            together both external experience of management challenges and best
            practices as well as an internal knowledge of the unique world of
            Microsoft. For two years have been consistently recognized as the
            top ranked facilitator with a sustained 4.85 score out of 5.0.
          </p>
          <p>
            ♦&nbsp;Brought together a team with diverse expertise and resources
            to work in Seoul, South Korea with U.S. and Korean participants that
            were both civilian and military personnel with the Army Corps of
            Engineers. Taking into consideration unique cultural and logistic
            parameters, the team designed and delivered customized Resiliency,
            Influencing and Negotiating, and Developing Future Leaders training.
          </p>
          <p>
            ♦&nbsp;Designed and facilitated a 2 day leadership retreat and
            ongoing long term team effectiveness coaching and training for the
            General Council and Legal Leadership Team within Flextronics. The
            program included extensive interviews with team members across
            global geographies and use of Behavioral Styles Inventory and
            several different OD tools to gain greater alignment, role
            responsibility and commitment behind the impacts of an organization
            wide expansion initiative.
          </p>
          <p>
            ♦&nbsp;Coordinate and facilitate with the Center for Creative
            Leadership a strategic planning simulation as part of the Leadership
            at the Peak program with Mars. Through the use of orienteering, the
            custom program is designed to provide a practice field for
            implementing several different psychometric and feedback tools for
            more effective team leadership. The participants are all worldwide
            business directors from Mars global brands.
          </p>
          <p>
            ♦&nbsp;Present to Senior Executives and GS-15s from over 20
            different U.S. federal government agencies how to create strategies
            to attract, hire and retain top talent as well as formulate
            distinctive team and organizational philosophies and brands. The
            focus is to harness commitment to the organizational mission with
            the use of rituals, culture, metaphor, ceremonies and symbolism
            through the genius and art of the storytelling leadership tool.
          </p>
          <div className="float-right">
            <img
              className="alignright"
              style={{ marginLeft: '18px', marginTop: '5px' }}
              src={Image2}
              alt="Work Projects"
              width={450}
            />
          </div>
          <p />
          <p>
            ♦&nbsp;Over a three year period, conducted leadership inventories,
            assessments and coaching of 17 department heads for German
            pharmaceutical – Schwarz Bioscience. Tools utilized included the
            Benchmarks 360° and the Campbell Leadership Index along with onsite
            coaching that lead to individual leadership development plans and 5
            yearlong organizational action learning projects. One project became
            a significant organization initiative that ultimately lead to an
            acquisition of a company in a pharmaceutical segment market.
          </p>
          <p>
            ♦&nbsp;Coached a Bank of America senior U.S. sales manager and his
            regional representatives on role value proposition and high
            performing team processes. A multi-day business simulation including
            a high ropes challenge course created a practice field to discover
            group core competencies and areas for both group and individual
            development opportunities. A team charter was then created that
            identified their purpose, values, brand, norms, roles and vision for
            success. The following year the sales team exceeded their revenue
            and market penetration goals by 11% and 7% respectively.
          </p>
          <p>
            ♦&nbsp;Associates working in tandem guided the leadership team of
            Open Sky Wilderness Therapies through creating a strategy for
            restructuring and transition of individuals into new positions,
            roles and responsibilities. Involved extensive interviews,
            consulting via conference calls and onsite facilitation of
            discussions with the founder and president of the organization and
            key department leaders. Together were able to outline the vision for
            the desired future state and the tactical plans with specific
            transition points and milestones to achieve the smooth and
            successful changeover in leadership roles.
          </p>
          <p>
            ♦&nbsp;Part of an international consulting team delivering in
            Barcelona, Spain the 5 day Senior Leadership at Kraft program with
            the focus on cross cultural agility. In a Kraft Foods, Inc.
            company-wide initiative for globalization, we were each responsible
            for working closely with 6 country product directors on
            supplementing identified individual leadership strengths with new
            skillsets. Peer feedback and coaching through a number of leadership
            challenges combined with presentations from academic experts were
            core aspects of the training.
          </p>
          <p>
            ♦&nbsp;Facilitated and implemented Max HR, a radical change to a
            “pay for performance” management system, throughout the U.S and
            overseas for 22 agencies within the U.S. Department of Homeland
            Security. The program required both an acceptance of a cultural mind
            shift and change in management beliefs and behaviors with specific
            skillset development. Was the most requested presenter with the
            highest evaluation scores over 2 ½ years of the cadre of 24
            facilitators.
          </p>
          <p>
            ♦&nbsp;Part of the rolled-out team for Creating the Future in
            Switzerland, Portugal and Greece, a world-wide organizational change
            initiative for Philip Morris International. This program
            fundamentally changed the adversarial philosophy and relationship of
            the tobacco industry with governments and the public to one of
            candidness about product health issues and cooperation of the
            company in responsibility for prevention of underage use of
            products.
          </p>
          <p>
            ♦&nbsp;Served as the program manager and trained multi-national
            facilitators for the delivery of General Motors Europe The Opel
            Difference, a 17 nation cultural change program for Opel dealership
            owners in Cadiz, Spain. Involvement and responsibilities in this
            year long program ranged from participating in the design of the $15
            million training project, conducting the train-the-trainer for the
            Hungarian, Italian and Spanish national trainers to supervision and
            running day to day logistic on the training site.
          </p>
        </div>
      </div>
    </div>
  </Layout>
)

export default IndexPage
